import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButtonDelete from '../../shared/atomic_components/button/CustomButtonDelete';
import {TextField} from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};

type ModalRifiutaSegnalazioneInterface = {
    openModalRifiutaSegnalazione : any,
    handleCloseModalRifiutaSegnalazione : any
}

const ModalRifiutaSegnalazione = ({
                                      openModalRifiutaSegnalazione,
                                      handleCloseModalRifiutaSegnalazione} : ModalRifiutaSegnalazioneInterface) => {

    return (
        <Modal
            open={openModalRifiutaSegnalazione}
            onClose={handleCloseModalRifiutaSegnalazione}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <div className="font-large-custom row">
                    <div className="col-auto">
                        Rifiuta segnalazione
                    </div>
                </div>
                <div className="font-medium-custom mt-3 mb-3">Sicuro di voler rifiutare la segnalazione?</div>
                <div>
                    <TextField
                        rows={3}
                        multiline
                        fullWidth={true}
                        label="Note del rifiuto"
                    />
                </div>
                <div className="mt-4 text-center col-12">
                    <CustomButtonDelete onClick={() => {handleCloseModalRifiutaSegnalazione()}} variant="contained">Rifiuta</CustomButtonDelete>
                </div>
            </Box>
        </Modal>
    );

}

export default ModalRifiutaSegnalazione;
